// Recovered compiled webpack factory 28033. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { O: () => a, e: () => o });
  var n = i(36874),
    s = i(19461),
    r = i(52036);
  function o(t) {
    return (0, n.N)(t.animate) || r._.some((e) => (0, s.w)(t[e]));
  }
  function a(t) {
    return !!(o(t) || t.variants);
  }
}
